import {Checkbox} from "@/components/UiElements";
import {useSnapshot} from "valtio";
import store from "@/store";
import updateSetting from "@/services/Settings/updateSetting";
import addSetting from "@/services/Settings/addSetting";
import CompanyBrandSettings from "./CompanyBrandSettings";
import CustomizationElementSettings from "@/components/Settings/CustomizationElementSettings/CustomizationElementSettings";
import ProfanityRulesSettings from "@/components/Settings/ProfanityRules/ProfanityRulesSettings";
import HelpTooltip from "@/components/UiElements/HelpTooltip";
import {settingsConfigHelp} from "@/components/Settings/configHelp";


const ThemeListView = () => {
    const {companySetting} = useSnapshot(store);

    const handleSelectMachine = async (checked: boolean) => {
        const machineName = checked ? "neatolabs" : null
        const res = await updateSetting({value: machineName, key: 'machine'});
        if (res?.response?.data?.error==='setting_not_found') {
            await addSetting({value: machineName, key: 'machine'});

        }
        store.companySetting.machine = machineName;
    }

    const handleSelectProfileVersion = async (checked: boolean) => {
        const profileVersion = checked ? "v2" : "v1"
        const res = await updateSetting({value: profileVersion, key: 'profile_version'});
        if (res?.response?.data?.error==='setting_not_found') {
            await addSetting({value: profileVersion, key: 'profile_version'});

        }
        store.companySetting.profile_version = profileVersion;
    }


    return (
        <div className="flex flex-col gap-xl pr-xxl">
            <div className="grid grid-cols-2 gap-xl">
                {/* Neatolabs Machine and Profile Version V2 checkboxes hidden per request.
                    Handlers (handleSelectMachine, handleSelectProfileVersion) kept intact below. */}
                <CustomizationElementSettings />
                <ProfanityRulesSettings />
            </div>
            <CompanyBrandSettings />
        </div>
    );
}

export default ThemeListView
